import React, { useEffect, useState } from "react"
import { clsx } from 'clsx'

import { ImageProps } from './ImageProps'


/**
 * ATOM - komponent obrazka z obsługą lazy loading, priorytetu ładowania oraz ponownych prób wczytania przy błędzie. 
 *        Jeśli nie uda się wczytać obrazka po określonej liczbie prób, przeglądarka wyświetli domyślny broken image.
 * @param props 
 * @returns 
 */
const Image: React.FC<ImageProps> = (props) => {
   const {
      src, alt, loading, className, style, loadingRetries = 2,
      lazy = true, highPriority = false, decoding = "async",
      ...rest
   } = props

   const [currentSrc, setCurrentSrc] = useState(src)
   const [loaded, setLoaded] = useState(false)
   const [errorCount, setErrorCount] = useState(0)

 
  // Reset stanu przy zmianie src
   useEffect(() => {
      setCurrentSrc(src)
      setLoaded(false)
      setErrorCount(0)
   }, [src])

   const handleLoad = () => {
      setLoaded(true)
   }

   const handleError = () => {
      if (errorCount < loadingRetries) {
         setErrorCount((c) => c + 1)
         setCurrentSrc(`${src}?retry=${Date.now()}`) // Wymuszenie ponownego pobrania z pominięciem cache
      }

      // Po przekroczeniu maxRetries nic nie robimy przeglądarka pokaże domyślny broken image
   }

   return (
      <img
         src={currentSrc}
         alt={alt}
         decoding={decoding}
         loading={lazy ? "lazy" : loading ?? "eager"}
         onLoad={handleLoad}
         onError={handleError}
         className={clsx('app-image', className, { 'app-image--loaded': loaded })}
         style={{...style }}
         {...rest}
      />
   )
}

export default Image